import styled from 'styled-components';

const StyledToolbar = styled.div`
  height: 90px;
  background: var(--sops-bg-white);
  border-bottom: 1px solid #e7e7e7;
  padding: 20px;
`;

export { StyledToolbar };
